// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"d7X1E":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", function() {
    return 0, _focusScope.FocusScope;
});
parcelHelpers.export(exports, "useFocusManager", function() {
    return 0, _focusScope.useFocusManager;
});
parcelHelpers.export(exports, "getFocusableTreeWalker", function() {
    return 0, _focusScope.getFocusableTreeWalker;
});
parcelHelpers.export(exports, "createFocusManager", function() {
    return 0, _focusScope.createFocusManager;
});
parcelHelpers.export(exports, "isElementInChildOfActiveScope", function() {
    return 0, _focusScope.isElementInChildOfActiveScope;
});
parcelHelpers.export(exports, "isFocusable", function() {
    return 0, _focusScope.isFocusable;
});
parcelHelpers.export(exports, "FocusRing", function() {
    return 0, _focusRing.FocusRing;
});
parcelHelpers.export(exports, "FocusableProvider", function() {
    return 0, _useFocusable.FocusableProvider;
});
parcelHelpers.export(exports, "useFocusable", function() {
    return 0, _useFocusable.useFocusable;
});
parcelHelpers.export(exports, "useFocusRing", function() {
    return 0, _useFocusRing.useFocusRing;
});
parcelHelpers.export(exports, "focusSafely", function() {
    return 0, _focusSafely.focusSafely;
});
parcelHelpers.export(exports, "useHasTabbableChild", function() {
    return 0, _useHasTabbableChild.useHasTabbableChild;
});
var _focusScope = require("./FocusScope");
var _focusRing = require("./FocusRing");
var _useFocusable = require("./useFocusable");
var _useFocusRing = require("./useFocusRing");
var _focusSafely = require("./focusSafely");
var _useHasTabbableChild = require("./useHasTabbableChild");

},{"./FocusScope":"cpmhS","./FocusRing":"3607i","./useFocusable":"01ByO","./useFocusRing":"bRp4G","./focusSafely":"iHhtz","./useHasTabbableChild":"l4064","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"cpmhS":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This is a hacky DOM-based implementation of a FocusScope until this RFC lands in React:
// https://github.com/reactjs/rfcs/pull/109
/**
 * A FocusScope manages focus for its descendants. It supports containing focus inside
 * the scope, restoring focus to the previously focused element on unmount, and auto
 * focusing children on mount. It also acts as a container for a programmatic focus
 * management interface that can be used to move focus forward and back in response
 * to user events.
 */ parcelHelpers.export(exports, "FocusScope", function() {
    return FocusScope;
});
/**
 * Returns a FocusManager interface for the parent FocusScope.
 * A FocusManager can be used to programmatically move focus within
 * a FocusScope, e.g. in response to user events like keyboard navigation.
 */ parcelHelpers.export(exports, "useFocusManager", function() {
    return useFocusManager;
});
parcelHelpers.export(exports, "isFocusable", function() {
    return isFocusable;
});
/** @private */ parcelHelpers.export(exports, "isElementInChildOfActiveScope", function() {
    return isElementInChildOfActiveScope;
});
/**
 * Create a [TreeWalker]{@link https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker}
 * that matches all focusable/tabbable elements.
 */ parcelHelpers.export(exports, "getFocusableTreeWalker", function() {
    return getFocusableTreeWalker;
});
/**
 * Creates a FocusManager object that can be used to move focus within an element.
 */ parcelHelpers.export(exports, "createFocusManager", function() {
    return createFocusManager;
});
parcelHelpers.export(exports, "focusScopeTree", function() {
    return focusScopeTree;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
var _focusSafely = require("./focusSafely");
var _utils = require("@react-aria/utils");
var _isElementVisible = require("./isElementVisible");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var FocusContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
var activeScope = null;
function FocusScope(props) {
    var children = props.children, contain = props.contain, restoreFocus = props.restoreFocus, autoFocus = props.autoFocus;
    var startRef = (0, _react.useRef)(null);
    var endRef = (0, _react.useRef)(null);
    var scopeRef = (0, _react.useRef)([]);
    var parentNode = ((0, _react.useContext)(FocusContext) || {}).parentNode;
    // Create a tree node here so we can add children to it even before it is added to the tree.
    var node = (0, _react.useMemo)(function() {
        return new TreeNode({
            scopeRef: scopeRef
        });
    }, [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(function() {
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        var parent = parentNode || focusScopeTree.root;
        if (focusScopeTree.getTreeNode(parent.scopeRef) && activeScope && !isAncestorScope(activeScope, parent.scopeRef)) {
            var activeNode = focusScopeTree.getTreeNode(activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        focusScopeTree.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var node = focusScopeTree.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        var node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        var nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    useActiveScopeTracker(scopeRef, restoreFocus, contain);
    useFocusContainment(scopeRef, contain);
    useRestoreFocus(scopeRef, restoreFocus, contain);
    useAutoFocus(scopeRef, autoFocus);
    // This needs to be an effect so that activeScope is updated after the FocusScope tree is complete.
    // It cannot be a useLayoutEffect because the parent of this node hasn't been attached in the tree yet.
    (0, _react.useEffect)(function() {
        var activeElement = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        var scope = null;
        if (isElementInScope(activeElement, scopeRef.current)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // We need to traverse the focusScope tree and find the bottom most scope that
                // contains the active element and set that as the activeScope.
                for(var _iterator = focusScopeTree.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (node.scopeRef && isElementInScope(activeElement, node.scopeRef.current)) scope = node;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (scope === focusScopeTree.getTreeNode(scopeRef)) activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    // This layout effect cleanup is so that the tree node is removed synchronously with react before the RAF
    // in useRestoreFocus cleanup runs.
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            var parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = focusScopeTree.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === activeScope || isAncestorScope(scopeRef, activeScope)) && (!parentScope || focusScopeTree.getTreeNode(parentScope))) activeScope = parentScope;
            focusScopeTree.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    var focusManager = (0, _react.useMemo)(function() {
        return createFocusManagerForScope(scopeRef);
    }, []);
    var value = (0, _react.useMemo)(function() {
        return {
            focusManager: focusManager,
            parentNode: node
        };
    }, [
        node,
        focusManager
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FocusContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function useFocusManager() {
    var _useContext;
    return (_useContext = (0, _react.useContext)(FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function createFocusManagerForScope(scopeRef) {
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[0].previousElementSibling;
            var scopeRoot = getScopeRoot(scope);
            var walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = isElementInScope(node, scope) ? node : sentinel;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[scope.length - 1].nextElementSibling;
            var scopeRoot = getScopeRoot(scope);
            var walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = isElementInScope(node, scope) ? node : sentinel;
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = getScopeRoot(scope);
            var walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            var nextNode = walker.nextNode();
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = getScopeRoot(scope);
            var walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            var previousNode = walker.previousNode();
            if (previousNode) focusElement(previousNode, true);
            return previousNode;
        }
    };
}
var focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
var FOCUSABLE_ELEMENT_SELECTOR = focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var TABBABLE_ELEMENT_SELECTOR = focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function isFocusable(element) {
    return element.matches(FOCUSABLE_ELEMENT_SELECTOR);
}
function getScopeRoot(scope) {
    return scope[0].parentElement;
}
function shouldContainFocus(scopeRef) {
    var scope = focusScopeTree.getTreeNode(activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function useFocusContainment(scopeRef, contain) {
    var focusedNode = (0, _react.useRef)();
    var raf = (0, _react.useRef)();
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !shouldContainFocus(scopeRef) || e.isComposing) return;
            var focusedElement = ownerDocument.activeElement;
            var scope = scopeRef.current;
            if (!scope || !isElementInScope(focusedElement, scope)) return;
            var scopeRoot = getScopeRoot(scope);
            var walker = getFocusableTreeWalker(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) focusElement(nextElement, true);
        };
        var onFocus = function(e) {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!activeScope || isAncestorScope(activeScope, scopeRef)) && isElementInScope(e.target, scopeRef.current)) {
                activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if (shouldContainFocus(scopeRef) && !isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if (activeScope && activeScope.current) focusFirstInScope(activeScope.current);
            } else if (shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        var onBlur = function(e) {
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(function() {
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && shouldContainFocus(scopeRef) && !isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
                    } else if (activeScope.current) focusFirstInScope(activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
            return element.addEventListener("focusout", onBlur, false);
        });
        return function() {
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
            scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
                return element.removeEventListener("focusout", onBlur, false);
            });
        };
    }, [
        scopeRef,
        contain
    ]);
    // This is a useLayoutEffect so it is guaranteed to run before our async synthetic blur
    // eslint-disable-next-line arrow-body-style
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function isElementInAnyScope(element) {
    return isElementInChildScope(element);
}
function isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some(function(node) {
        return node.contains(element);
    });
}
function isElementInChildScope(element) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // node.contains in isElementInScope covers child scopes that are also DOM children,
        // but does not cover child scopes in portals.
        for(var _iterator = focusScopeTree.traverse(focusScopeTree.getTreeNode(scope))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, s = _step_value.scopeRef;
            if (s && isElementInScope(element, s.current)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function isElementInChildOfActiveScope(element) {
    return isElementInChildScope(element, activeScope);
}
function isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    var parent = (_focusScopeTree_getTreeNode = focusScopeTree.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function focusElement(element) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (element != null && !scroll) try {
        (0, _focusSafely.focusSafely)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function focusFirstInScope(scope) {
    var tabbable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var sentinel = scope[0].previousElementSibling;
    var scopeRoot = getScopeRoot(scope);
    var walker = getFocusableTreeWalker(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    var nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = getScopeRoot(scope);
        walker = getFocusableTreeWalker(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    focusElement(nextNode);
}
function useAutoFocus(scopeRef, autoFocus) {
    var autoFocusRef = (0, _reactDefault.default).useRef(autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current) {
            activeScope = scopeRef;
            var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!isElementInScope(ownerDocument.activeElement, activeScope.current) && scopeRef.current) focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function useActiveScopeTracker(scopeRef, restore, contain) {
    // tracks the active scope, in case restore and contain are both false.
    // if either are true, this is tracked in useRestoreFocus or useFocusContainment.
    (0, _utils.useLayoutEffect)(function() {
        if (restore || contain) return;
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        var onFocus = function(e) {
            var target = e.target;
            if (isElementInScope(target, scopeRef.current)) activeScope = scopeRef;
            else if (!isElementInAnyScope(target)) activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function shouldRestoreFocus(scopeRef) {
    var scope = focusScopeTree.getTreeNode(activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    var nodeToRestoreRef = (0, _react.useRef)(typeof document !== "undefined" ? (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    // restoring scopes should all track if they are active regardless of contain, but contain already tracks it plus logic to contain the focus
    // restoring-non-containing scopes should only care if they become active so they can perform the restore
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        var onFocus = function() {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!activeScope || isAncestorScope(activeScope, scopeRef)) && isElementInScope(ownerDocument.activeElement, scopeRef.current)) activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 ? void 0 : scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !shouldContainFocus(scopeRef) || e.isComposing) return;
            var focusedElement = ownerDocument.activeElement;
            if (!isElementInScope(focusedElement, scopeRef.current)) return;
            var treeNode = focusScopeTree.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            var walker = getFocusableTreeWalker(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while (isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) focusElement(nextElement, true);
                else // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
                // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return function() {
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        var treeNode = focusScopeTree.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return function() {
            var treeNode = focusScopeTree.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            (isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                var clonedTree = focusScopeTree.clone();
                requestAnimationFrame(function() {
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        var treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && focusScopeTree.getTreeNode(treeNode.scopeRef)) {
                                focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function getFocusableTreeWalker(root, opts, scope) {
    var selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? TABBABLE_ELEMENT_SELECTOR : FOCUSABLE_ELEMENT_SELECTOR;
    var walker = (0, _utils.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, _isElementVisible.isElementVisible)(node) && (!scope || isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function createFocusManager(ref) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, _opts_tabbable = opts.tabbable, tabbable = _opts_tabbable === void 0 ? defaultOptions.tabbable : _opts_tabbable, _opts_wrap = opts.wrap, wrap = _opts_wrap === void 0 ? defaultOptions.wrap : _opts_wrap, _opts_accept = opts.accept, accept = _opts_accept === void 0 ? defaultOptions.accept : _opts_accept;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = getFocusableTreeWalker(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, _opts_tabbable = opts.tabbable, tabbable = _opts_tabbable === void 0 ? defaultOptions.tabbable : _opts_tabbable, _opts_wrap = opts.wrap, wrap = _opts_wrap === void 0 ? defaultOptions.wrap : _opts_wrap, _opts_accept = opts.accept, accept = _opts_accept === void 0 ? defaultOptions.accept : _opts_accept;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = getFocusableTreeWalker(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                var next = last(walker);
                if (next) focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                var lastNode = last(walker);
                if (!lastNode) // couldn't wrap
                return null;
                previousNode = lastNode;
            }
            if (previousNode) focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var _opts_tabbable = opts.tabbable, tabbable = _opts_tabbable === void 0 ? defaultOptions.tabbable : _opts_tabbable, _opts_accept = opts.accept, accept = _opts_accept === void 0 ? defaultOptions.accept : _opts_accept;
            var walker = getFocusableTreeWalker(root, {
                tabbable: tabbable,
                accept: accept
            });
            var nextNode = walker.nextNode();
            if (nextNode) focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var _opts_tabbable = opts.tabbable, tabbable = _opts_tabbable === void 0 ? defaultOptions.tabbable : _opts_tabbable, _opts_accept = opts.accept, accept = _opts_accept === void 0 ? defaultOptions.accept : _opts_accept;
            var walker = getFocusableTreeWalker(root, {
                tabbable: tabbable,
                accept: accept
            });
            var next = last(walker);
            if (next) focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function last(walker) {
    var next = undefined;
    var last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
var Tree = /*#__PURE__*/ function() {
    "use strict";
    function Tree() {
        (0, _classCallCheck._)(this, Tree);
        this.fastMap = new Map();
        this.root = new TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    (0, _createClass._)(Tree, [
        {
            key: "size",
            get: function get() {
                return this.fastMap.size;
            }
        },
        {
            key: "getTreeNode",
            value: function getTreeNode(data) {
                return this.fastMap.get(data);
            }
        },
        {
            key: "addTreeNode",
            value: function addTreeNode(scopeRef, parent, nodeToRestore) {
                var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
                if (!parentNode) return;
                var node = new TreeNode({
                    scopeRef: scopeRef
                });
                parentNode.addChild(node);
                node.parent = parentNode;
                this.fastMap.set(scopeRef, node);
                if (nodeToRestore) node.nodeToRestore = nodeToRestore;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                this.fastMap.set(node.scopeRef, node);
            }
        },
        {
            key: "removeTreeNode",
            value: function removeTreeNode(scopeRef) {
                // never remove the root
                if (scopeRef === null) return;
                var node = this.fastMap.get(scopeRef);
                if (!node) return;
                var parentNode = node.parent;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
                    // if we are, then replace the siblings restore with the restore from the scope we're removing
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var current = _step.value;
                        if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var children = node.children;
                if (parentNode) {
                    parentNode.removeChild(node);
                    if (children.size > 0) children.forEach(function(child) {
                        return parentNode && parentNode.addChild(child);
                    });
                }
                this.fastMap.delete(node.scopeRef);
            }
        },
        {
            key: "traverse",
            value: // Pre Order Depth First
            function traverse() {
                var node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, err;
                var _arguments = arguments;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.root;
                            if (!(node.scopeRef != null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                node
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!(node.children.size > 0)) return [
                                3,
                                10
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = node.children[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            child = _step.value;
                            return [
                                5,
                                (0, _tsValues._)(this.traverse(child))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "clone",
            value: function clone() {
                var _node_parent;
                var newTree = new Tree();
                var _node_parent_scopeRef;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newTree;
            }
        }
    ]);
    return Tree;
}();
var TreeNode = /*#__PURE__*/ function() {
    "use strict";
    function TreeNode(props) {
        (0, _classCallCheck._)(this, TreeNode);
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    (0, _createClass._)(TreeNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.children.add(node);
                node.parent = this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.children.delete(node);
                node.parent = undefined;
            }
        }
    ]);
    return TreeNode;
}();
var focusScopeTree = new Tree();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_ts_generator":"hIXl2","@swc/helpers/_/_ts_values":"4WEPh","./focusSafely":"iHhtz","@react-aria/utils":"g2eof","./isElementVisible":"aEI64","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"4WEPh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
parcelHelpers.export(exports, "_ts_values", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"h1Nlh","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"iHhtz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A utility function that focuses an element while avoiding undesired side effects such
 * as page scrolling and screen reader issues with CSS transitions.
 */ parcelHelpers.export(exports, "focusSafely", function() {
    return focusSafely;
});
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
function focusSafely(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    var ownerDocument = (0, _utils.getOwnerDocument)(element);
    if ((0, _interactions.getInteractionModality)() === "virtual") {
        var lastFocusedElement = ownerDocument.activeElement;
        (0, _utils.runAfterTransition)(function() {
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, _utils.focusWithoutScrolling)(element);
        });
    } else (0, _utils.focusWithoutScrolling)(element);
}

},{"@react-aria/utils":"g2eof","@react-aria/interactions":"1h5DV","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"aEI64":[function(require,module,exports) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Adapted from https://github.com/testing-library/jest-dom and
 * https://github.com/vuejs/vue-test-utils-next/.
 * Licensed under the MIT License.
 * @param element - Element to evaluate for display or visibility.
 */ parcelHelpers.export(exports, "isElementVisible", function() {
    return isElementVisible;
});
var _utils = require("@react-aria/utils");
function isStyleVisible(element) {
    var windowObject = (0, _utils.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    var _element_style = element.style, display = _element_style.display, visibility = _element_style.visibility;
    var isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        var getComputedStyle = element.ownerDocument.defaultView.getComputedStyle;
        var _getComputedStyle = getComputedStyle(element), computedDisplay = _getComputedStyle.display, computedVisibility = _getComputedStyle.visibility;
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function isElementVisible(element, childElement) {
    return element.nodeName !== "#comment" && isStyleVisible(element) && isAttributeVisible(element, childElement) && (!element.parentElement || isElementVisible(element.parentElement, element));
}

},{"@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"3607i":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A utility component that applies a CSS class when an element has keyboard focus.
 * Focus rings are visible only when the user is interacting with a keyboard,
 * not with a mouse, touch, or other input methods.
 */ parcelHelpers.export(exports, "FocusRing", function() {
    return FocusRing;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFocusRing = require("./useFocusRing");
function FocusRing(props) {
    var children = props.children, focusClass = props.focusClass, focusRingClass = props.focusRingClass;
    var _useFocusRing1 = (0, _useFocusRing.useFocusRing)(props), isFocused = _useFocusRing1.isFocused, isFocusVisible = _useFocusRing1.isFocusVisible, focusProps = _useFocusRing1.focusProps;
    var child = (0, _reactDefault.default).Children.only(children);
    var _obj;
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, (0, _utils.mergeProps)(child.props, (0, _objectSpreadProps._)((0, _objectSpread._)({}, focusProps), {
        className: (0, _clsxDefault.default)((_obj = {}, (0, _defineProperty._)(_obj, focusClass || "", isFocused), (0, _defineProperty._)(_obj, focusRingClass || "", isFocusVisible), _obj))
    })));
}

},{"@swc/helpers/_/_define_property":"5nkYf","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","clsx":"CejKb","@react-aria/utils":"g2eof","react":"lbBKc","./useFocusRing":"bRp4G","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bRp4G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines whether a focus ring should be shown to indicate keyboard focus.
 * Focus rings are visible only when the user is interacting with a keyboard,
 * not with a mouse, touch, or other input methods.
 */ parcelHelpers.export(exports, "useFocusRing", function() {
    return useFocusRing;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _interactions = require("@react-aria/interactions");
var _react = require("react");
function useFocusRing() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? false : _props_autoFocus, isTextInput = props.isTextInput, within = props.within;
    var state = (0, _react.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, _interactions.isFocusVisible)()
    });
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _useState[0], setFocused = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return state.current.isFocused && state.current.isFocusVisible;
    }), 2), isFocusVisibleState = _useState1[0], setFocusVisible = _useState1[1];
    var updateState = (0, _react.useCallback)(function() {
        return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
    }, []);
    var onFocusChange = (0, _react.useCallback)(function(isFocused) {
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, _interactions.useFocusVisibleListener)(function(isFocusVisible) {
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    var focusProps = (0, _interactions.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    }).focusProps;
    var focusWithinProps = (0, _interactions.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    }).focusWithinProps;
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","@react-aria/interactions":"1h5DV","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"01ByO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusableProvider", function() {
    return _FocusableProvider;
});
/**
 * Used to make an element focusable and capable of auto focus.
 */ parcelHelpers.export(exports, "useFocusable", function() {
    return useFocusable;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _ = require("./");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var FocusableContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useFocusableContext(ref) {
    var context = (0, _react.useContext)(FocusableContext) || {};
    (0, _utils.useSyncRef)(context, ref);
    // eslint-disable-next-line
    var _ = context.ref, otherProps = (0, _objectWithoutProperties._)(context, [
        "ref"
    ]);
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function FocusableProvider(props, ref) {
    var children = props.children, otherProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    var objRef = (0, _utils.useObjectRef)(ref);
    var context = (0, _objectSpreadProps._)((0, _objectSpread._)({}, otherProps), {
        ref: objRef
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FocusableContext.Provider, {
        value: context
    }, children);
}
var _FocusableProvider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(FocusableProvider);
function useFocusable(props, domRef) {
    var focusProps = (0, _interactions.useFocus)(props).focusProps;
    var keyboardProps = (0, _interactions.useKeyboard)(props).keyboardProps;
    var interactions = (0, _utils.mergeProps)(focusProps, keyboardProps);
    var domProps = useFocusableContext(domRef);
    var interactionProps = props.isDisabled ? {} : domProps;
    var autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current && domRef.current) (0, _.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, _utils.mergeProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, interactions), {
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }), interactionProps)
    };
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","./":"d7X1E","@react-aria/utils":"g2eof","react":"lbBKc","@react-aria/interactions":"1h5DV","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"l4064":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This was created for a special empty case of a component that can have child or
// be empty, like Collection/Virtualizer/Table/ListView/etc. When these components
// are empty they can have a message with a tabbable element, which is like them
// being not empty, when it comes to focus and tab order.
/**
 * Returns whether an element has a tabbable child, and updates as children change.
 * @private
 */ parcelHelpers.export(exports, "useHasTabbableChild", function() {
    return useHasTabbableChild;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _focusScope = require("./FocusScope");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useHasTabbableChild(ref, options) {
    var isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hasTabbableChild = _useState[0], setHasTabbableChild = _useState[1];
    (0, _utils.useLayoutEffect)(function() {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            var update = function() {
                if (ref.current) {
                    var walker = (0, _focusScope.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            var observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return function() {
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","./FocusScope":"cpmhS","react":"lbBKc","@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=useButton.stories.e43caa8d.js.map
